import { render, staticRenderFns } from "./Ramplas.vue?vue&type=template&id=178da92d&scoped=true&"
import script from "./Ramplas.vue?vue&type=script&lang=ts&"
export * from "./Ramplas.vue?vue&type=script&lang=ts&"
import style0 from "./Ramplas.vue?vue&type=style&index=0&id=178da92d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178da92d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('178da92d', component.options)
    } else {
      api.reload('178da92d', component.options)
    }
    module.hot.accept("./Ramplas.vue?vue&type=template&id=178da92d&scoped=true&", function () {
      api.rerender('178da92d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Ramplas/Ramplas.vue"
export default component.exports